export default __webpack_public_path__ + "static/media/not-found.0fac64ef.svg";